import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'dm-self-service-response',
		path: '/p/:slug/dm/respond',
		component: loadable(
			async () => import(/* webpackChunkName: "pages/decisionMaker-response-selfService" */ './index'),
			{
				exportName: 'DmSelfServiceResponse',
				fallback: Loading,
			},
		),
		// no restricted access as this is done using a dedicated token in the `rt` query param;
		// the URL slug is never used to authorize anything
		frame: false,
		ssr: {
			enabled: false,
			seo: false,
		},
	},
];
